module.exports = __webpack_public_path__ + "img/ltkbuynow-1x.509dc4b.jpg";